<template>
	<div>
    <vs-checkbox v-model="VALUE" @change="onChange()">
    </vs-checkbox>
	</div>
</template>
<script>
export default {
	data() {
		return {
			VALUE: "",
		};
	},
  methods:{
    onChange() {
      this.params.api.stopEditing();
      this.params.setValue(this.VALUE); 
    },
  },
  
	created() {
		this.VALUE = this.params.value;
	},
};
</script>
		